import { render, staticRenderFns } from "./SchoolDataOverview.vue?vue&type=template&id=25d8d11e&scoped=true"
import script from "./SchoolDataOverview.vue?vue&type=script&lang=js"
export * from "./SchoolDataOverview.vue?vue&type=script&lang=js"
import style0 from "./SchoolDataOverview.vue?vue&type=style&index=0&id=25d8d11e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d8d11e",
  null
  
)

export default component.exports